import { render, staticRenderFns } from "./ClientDetailsForm.vue?vue&type=template&id=75c5c6d7&scoped=true&"
import script from "./ClientDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ClientDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailsForm.vue?vue&type=style&index=0&id=75c5c6d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c5c6d7",
  null
  
)

export default component.exports